export default __webpack_public_path__ + "static/media/sticker-O.b54d737e.png";